// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vhallPlayer-thumbnail {\n  display: block;\n  position: absolute;\n  top: -100px;\n  width: 160px;\n  height: 90px;\n}\n.vhallPlayer-thumbnail.hide {\n  display: none;\n}\n\n.vhallPlayer-thumbnail-spot-time {\n  position: absolute;\n  left: 50%;\n  bottom: 2px;\n  font-size: 12px;\n  line-height: 16.8px;\n  left: 50%;\n  transform: translateX(-50%);\n  pointer-events: none;\n  color: #eee;\n  background-color: #333;\n}\n", ""]);
// Exports
module.exports = exports;
